import { Glyphicon } from 'react-bootstrap';
import { CloseButton } from '../EnrollmentModal.styles';

interface CloseModalButtonProps {
  label: string;
  onClick: () => void;
}

const CloseModalButton = ({ label, onClick }: CloseModalButtonProps) => (
  <CloseButton type="button" aria-label={label} onClick={onClick}>
    <Glyphicon glyph="remove" aria-hidden />
  </CloseButton>
);

export default CloseModalButton;
